import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  description: {
    id: 'studio.Q8Qw5B',
    defaultMessage: 'Description',
  },
  view: {
    id: 'studio.nevxi8',
    defaultMessage: 'View app',
  },
  readMore: {
    id: 'studio.S++WdB',
    defaultMessage: 'Read more',
  },
  readLess: {
    id: 'studio.Ed2ywJ',
    defaultMessage: 'Read less',
  },
  demo: {
    id: 'studio.JsZpzQ',
    defaultMessage: 'demo',
  },
  shareApp: {
    id: 'studio.bIGB4X',
    defaultMessage: 'Share app',
  },
});
